var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-card",class:[
    { 'profile-card_background': _vm.background },
    `profile-card_size-${_vm.size}`,
  ]},[_c('img',{staticClass:"profile-card__image",attrs:{"src":_vm.userImage,"alt":"logo profile"}}),_c('div',{staticClass:"profile-card__box"},[_c('span',{staticClass:"profile-card__name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"profile-card__tariff-box"},[_c('span',{class:_vm.iconClassTariff}),_c('span',[_vm._v(_vm._s(_vm.tariff.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }